'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setCountryCode = setCountryCode;
exports.setIsPublic = setIsPublic;
exports.default = meta;
var SET_COUNTRY_CODE = exports.SET_COUNTRY_CODE = 'SET_COUNTRY_CODE';
var SET_IS_PUBLIC = exports.SET_IS_PUBLIC = 'SET_IS_PUBLIC';

function setCountryCode(code) {
  if (typeof code !== 'string') throw new Error('code is required and must be a string -- received: ' + code);
  return { type: SET_COUNTRY_CODE, code: code };
}

function setIsPublic(value) {
  if (typeof value !== 'boolean') throw new Error('value is required and must be a boolean -- received: ' + value);
  return { type: SET_IS_PUBLIC, value: value };
}

var initialState = exports.initialState = { country: 'US' };

function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_COUNTRY_CODE:
      return _extends({}, state, { country: action.code });
    case SET_IS_PUBLIC:
      return _extends({}, state, { isPublic: action.value });
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/utils/utilsModule.js
// module id = 129
// module chunks = 0